import type {
  TechnicalPassportDimensions,
  TechnicalPassportElement,
  TechnicalPassportYarn,
} from './types'

export const sockDimensionFields: Array<{
  key: keyof TechnicalPassportDimensions
  labelKey: string
  code: string
  measurementKey: string
  toleranceKey: string
  unitKey: string
}> = [
  {
    key: 'leg_height_mm',
    labelKey: 'engineering.passportStructure.dimensionField.leg_height_mm.label',
    code: 'A',
    measurementKey: 'engineering.passportStructure.dimensionField.leg_height_mm.measurement',
    toleranceKey: 'engineering.passportStructure.dimensionField.leg_height_mm.tolerance',
    unitKey: 'engineering.passportStructure.dimensionField.leg_height_mm.unit',
  },
  {
    key: 'instep_length_mm',
    labelKey: 'engineering.passportStructure.dimensionField.instep_length_mm.label',
    code: 'B',
    measurementKey: 'engineering.passportStructure.dimensionField.instep_length_mm.measurement',
    toleranceKey: 'engineering.passportStructure.dimensionField.instep_length_mm.tolerance',
    unitKey: 'engineering.passportStructure.dimensionField.instep_length_mm.unit',
  },
  {
    key: 'foot_length_mm',
    labelKey: 'engineering.passportStructure.dimensionField.foot_length_mm.label',
    code: 'C',
    measurementKey: 'engineering.passportStructure.dimensionField.foot_length_mm.measurement',
    toleranceKey: 'engineering.passportStructure.dimensionField.foot_length_mm.tolerance',
    unitKey: 'engineering.passportStructure.dimensionField.foot_length_mm.unit',
  },
  {
    key: 'cuff_width_mm',
    labelKey: 'engineering.passportStructure.dimensionField.cuff_width_mm.label',
    code: 'D',
    measurementKey: 'engineering.passportStructure.dimensionField.cuff_width_mm.measurement',
    toleranceKey: 'engineering.passportStructure.dimensionField.cuff_width_mm.tolerance',
    unitKey: 'engineering.passportStructure.dimensionField.cuff_width_mm.unit',
  },
  {
    key: 'foot_width_mm',
    labelKey: 'engineering.passportStructure.dimensionField.foot_width_mm.label',
    code: 'E',
    measurementKey: 'engineering.passportStructure.dimensionField.foot_width_mm.measurement',
    toleranceKey: 'engineering.passportStructure.dimensionField.foot_width_mm.tolerance',
    unitKey: 'engineering.passportStructure.dimensionField.foot_width_mm.unit',
  },
  {
    key: 'heel_length_mm',
    labelKey: 'engineering.passportStructure.dimensionField.heel_length_mm.label',
    code: 'F',
    measurementKey: 'engineering.passportStructure.dimensionField.heel_length_mm.measurement',
    toleranceKey: 'engineering.passportStructure.dimensionField.heel_length_mm.tolerance',
    unitKey: 'engineering.passportStructure.dimensionField.heel_length_mm.unit',
  },
  {
    key: 'cuff_height_mm',
    labelKey: 'engineering.passportStructure.dimensionField.cuff_height_mm.label',
    code: 'G',
    measurementKey: 'engineering.passportStructure.dimensionField.cuff_height_mm.measurement',
    toleranceKey: 'engineering.passportStructure.dimensionField.cuff_height_mm.tolerance',
    unitKey: 'engineering.passportStructure.dimensionField.cuff_height_mm.unit',
  },
  {
    key: 'toe_length_mm',
    labelKey: 'engineering.passportStructure.dimensionField.toe_length_mm.label',
    code: 'H',
    measurementKey: 'engineering.passportStructure.dimensionField.toe_length_mm.measurement',
    toleranceKey: 'engineering.passportStructure.dimensionField.toe_length_mm.tolerance',
    unitKey: 'engineering.passportStructure.dimensionField.toe_length_mm.unit',
  },
]

export const elementTypes = ['cuff', 'toe', 'heel', 'mesh', 'compression_band', 'elastic_band', 'stripe', 'logo', 'jacquard', 'custom']
export const positionCodes = ['top_cuff', 'leg_front', 'leg_back', 'ankle_area', 'heel_area', 'toe_area', 'sole_area', 'instep_area', 'custom']
export const knitTypes = ['plain', 'rib_1x1', 'rib_2x2', 'reinforced', 'terry', 'mesh', 'elastic', 'jacquard']
export const patternTypes = ['hatch', 'rib', 'mesh', 'dots', 'waves']
export const yarnRoles = ['main', 'secondary', 'reinforcement', 'elastic', 'decorative']

export function defaultSockElements(
  dimensions: TechnicalPassportDimensions,
): TechnicalPassportElement[] {
  return [
    { element_type: 'cuff', position_code: 'top_cuff', length_mm: dimensions.cuff_height_mm, width_mm: dimensions.cuff_width_mm, height_mm: dimensions.cuff_height_mm, knit_type: 'rib_1x1', yarn_role: 'main', pattern_type: 'rib', is_required: true, sort_order: 1, comment: 'Auto-generated cuff zone' },
    { element_type: 'heel', position_code: 'heel_area', length_mm: dimensions.heel_length_mm, knit_type: 'reinforced', yarn_role: 'secondary', pattern_type: 'hatch', is_required: true, sort_order: 2, comment: 'Auto-generated heel zone' },
    { element_type: 'toe', position_code: 'toe_area', length_mm: dimensions.toe_length_mm, knit_type: 'reinforced', yarn_role: 'secondary', pattern_type: 'hatch', is_required: true, sort_order: 3, comment: 'Auto-generated toe zone' },
    { element_type: 'mesh', position_code: 'instep_area', length_mm: dimensions.instep_length_mm, knit_type: 'mesh', yarn_role: 'main', pattern_type: 'mesh', is_required: false, sort_order: 4, comment: 'Auto-generated instep zone' },
  ]
}

export function defaultSockYarns(): TechnicalPassportYarn[] {
  return [
    { role: 'main', yarn_type: 'cotton', yarn_composition: 'Primary yarn', color_name: 'Main', color_code: '#ffffff', comment: 'Primary yarn', sort_order: 1 },
    { role: 'secondary', yarn_type: 'spandex', yarn_composition: 'Secondary yarn', color_name: 'Secondary', color_code: '#d4d4d8', comment: 'Secondary yarn', sort_order: 2 },
    { role: 'reinforcement', yarn_type: 'nylon', yarn_composition: 'Reinforcement yarn', color_name: 'Reinforcement', color_code: '#a1a1aa', comment: 'Reinforcement yarn', sort_order: 3 },
  ]
}
